import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/vue-echarts/official-demo-001',
            name: 'admin-vue-echarts-official-demo-001',
            component: () => import(/* webpackChunkName: "page-admin-default-vue-echarts-official-demo-001" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "官方demo-001"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "vue-echarts"
                            },
                            {
                                name: "官方demo-001"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
